/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Button, Modal, Radio } from '@scuf/common';
import React, { useState, useContext, useEffect } from 'react';
import './UpdatedUtilityServiceCommon.scss';
import ChooseServiceTab from './ChooseServiceTab/ChooseServiceTab';
import descriptors from '../../locales/en-US/descriptors';
import UtilityModalForm from './UtilityModalForm';
import useConnectorForPost from '../shared/useConnectorAndDynamicProps/useConnectorForPost';
import {
  IAllConnectDetails,
  ICommonServiceProps,
  IUtilityProviders,
  IManualAccountDetails
} from './IUtilityService';
import UtilityAccountAction from '../../context/UtilityAccountContext/UtilityAccountActions';
import { useUtilityAccountContext } from '../../context/UtilityAccountContext/UtilityAccountContext';
import { useTranslation } from '@scuf/localization';
import {
  SpecialCharacter,
  isObjectEmpty,
  validateConnecttabInput
} from '../shared/Utils/Utils';
import { ApiContext } from '../../context/ApiContext';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';
import { getEnrollNotifyInfo } from '../shared/Utils/UtilitySettings/UtilitySettingsUtils';
import ProgressTab from './ProgressTab/ProgressTab';
import UpdatedChooseServiceTab from './ChooseServiceTab/UpdatedChooseServiceTab';

function UpdatedUtilityServiceModal(props: ICommonServiceProps) {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const { bearerToken } = props;
  const [utilityTyp, setUtilityTyp] = useState('Automated');
  const [state, dispatch] = useUtilityAccountContext();
  const { showModal } = state;
  let { requestContext, utilityType } = props;
  const closeModal = () => {
    setAllConnectDetails(initDetails);
    SetSelectedUtilityProvider({} as IUtilityProviders);
    setSubmitted(false);
    setAccountNumcheck(false);
    dispatch(UtilityAccountAction.hideUtilityModal());
    setManualAccountUtility([] as IManualAccountDetails);
    //setManualAccountUtility(([] as unknown) as IManualAccountDetails);
    setUtilityTyp('Automated');
    setProgressTab(false);
    setAddUtilityTable(false);
    setIsSpecialCharacter(false);
  };

  const initDetails = {
    accountDetails: [],
    username: '',
    usernameError: '',
    password: '',
    passwordError: ''
  };
  const [allConnectDetails, setAllConnectDetails] = useState<
    IAllConnectDetails
  >(initDetails);
  const [SelectedUtilityProvider, SetSelectedUtilityProvider] = useState<
    IUtilityProviders
  >({} as IUtilityProviders);
  const [isSubmitted, setSubmitted] = useState(false);
  const [isDisabled, setDisabled] = useState(true);
  const [manualDisabled, setManualDisabled] = useState(false);
  const [accUtility, setAccUtility] = useState({
    accountNumber: '',
    utility: '',
    idsEnabled: false
  });
  const [manualAccountUtility, setManualAccountUtility] = useState<
    IManualAccountDetails
  >([] as IManualAccountDetails);
  //(([] as any) as IManualAccountDetails);
  const [AccountNumcheck, setAccountNumcheck] = useState(false);
  const [addUtilityTable, setAddUtilityTable] = useState(false);
  const [progressTab, setProgressTab] = useState(false);
  const [isSpecialCharacter, setIsSpecialCharacter] = useState(false);
  const chooseServiceProps = {
    bearerToken: bearerToken,
    requestContext: requestContext,
    SetSelectedUtilityProvider: SetSelectedUtilityProvider,
    SelectedUtilityProvider: SelectedUtilityProvider,
    utilityTyp: utilityTyp,
    setIsSpecialCharacter: setIsSpecialCharacter,
    isSpecialCharacter: isSpecialCharacter
  };

  const emaasContext = useContext(ApiContext);
  const ProgressTabProps = {
    closeModal: closeModal
  };
  const connectorConfig = {
    name:
      utilityTyp === 'Automated'
        ? 'enroll-utility-accounts'
        : 'enroll-manual-utility-account'
  };
  const dataConnector = useConnectorForPost({
    connectorConfig,
    requestContext,
    bearerToken
  });
  const validateMandatoryFields = () => {
    const { isValid, tempValidation } = validateConnecttabInput(
      allConnectDetails
    );
    setAllConnectDetails({ ...tempValidation });
    return isValid;
  };

  useEffect(() => {
    setAllConnectDetails(initDetails);
    SetSelectedUtilityProvider({} as IUtilityProviders);
    setSubmitted(false);
    setManualAccountUtility(([] as any) as IManualAccountDetails);
    setAddUtilityTable(false);
  }, [utilityTyp]);

  useEffect(() => {
    if (
      allConnectDetails.password !== '' &&
      allConnectDetails.username !== '' &&
      !isObjectEmpty(SelectedUtilityProvider) &&
      allConnectDetails.accountDetails.length > 0
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [allConnectDetails, SelectedUtilityProvider]);

  useEffect(() => {
    if (
      !isObjectEmpty(SelectedUtilityProvider) &&
      manualAccountUtility &&
      manualAccountUtility.length > 0
    ) {
      // setManualDisabled(false);
      manualAccountUtility.map((account) => {
        if (
          account.accountNumber.endsWith(' ') ||
          account.accountNumber.endsWith('-')
        ) {
          setManualDisabled(true);
        } else {
          setManualDisabled(false);
        }
      });
    } else {
      setManualDisabled(true);
    }
  }, [manualAccountUtility, SelectedUtilityProvider]);

  const connectProps = {
    allConnectDetails: allConnectDetails,
    setAllConnectDetails: setAllConnectDetails,
    isSubmitted: isSubmitted,
    validateMandatoryFields: validateMandatoryFields,
    setAccUtility: setAccUtility,
    accUtility: accUtility,
    addUtilityTable: addUtilityTable,
    setAddUtilityTable: setAddUtilityTable,
    utilityTyp: utilityTyp,
    setManualAccountUtility: setManualAccountUtility,
    manualAccountUtility: manualAccountUtility,
    AccountNumcheck: AccountNumcheck,
    setAccountNumcheck: setAccountNumcheck
  };
  const apiContext = useContext(ApiContext);
  const { notifyMessage } = apiContext;

  const submit = async () => {
    setSubmitted(true);
    const isValid = true; //validateMandatoryFields();
    if (isValid) {
      const requestBody = {
        credential: btoa(
          `${allConnectDetails.username}:${allConnectDetails.password}`
        ),
        serviceProviderId: SelectedUtilityProvider.utilityProviderId,
        serviceProviderName: SelectedUtilityProvider.utilityProviderName,
        subscribed: true,
        pullHistory: true,
        siteId: emaasContext.siteId,
        accountDetails: allConnectDetails.accountDetails.map((account) => {
          const utilityDetails = JSON.parse(
            account.utility ? account.utility : ''
          );
          return {
            accountNumber: account.accountNumber?.toString(),
            serviceTypeId: utilityDetails.id,
            idsEnabled: account.idsEnabled
          };
        })
      };
      setProgressTab(true);
      const result: IAny = await dataConnector.actions.create(requestBody);
      const { notifyDescription, notifyType } = getEnrollNotifyInfo(result);
      notifyMessage && notifyMessage(t(notifyDescription), notifyType);
    }
  };

  const specialChars = /[`!#$%*^@+\=\\;:\\|<>\/?~]/;

  const specialCharacterCheck = (value: string) => specialChars.test(value);
  const manualSubmit = async () => {
    if (!specialCharacterCheck(SelectedUtilityProvider.utilityProviderName)) {
      setSubmitted(true);
      setAccountNumcheck(false);
      const requestBody = {
        serviceProviderId: SelectedUtilityProvider.utilityProviderId,
        serviceProviderName: SelectedUtilityProvider.utilityProviderName,
        subscribed: true,
        pullHistory: true,
        siteId: emaasContext.siteId,
        manualAccountDetails:
          manualAccountUtility.length > 0 &&
          manualAccountUtility.map((account) => {
            const manualUtiltyData = JSON.parse(
              account.utility ? account.utility : ''
            );
            return {
              accountNumber: account.accountNumber,
              serviceTypeId: manualUtiltyData.id,
              serviceTypeName: manualUtiltyData.name,
              consumptionUnit: account.consumptionUnit,
              demandUnit: account.demandUnit,
              currencyUnit: account.currencyUnit,
              utilityAccountId: account.utilityAccountId,
              manualMeterDetails: account.manualMeterDetails
            };
          })
      };
      setProgressTab(true);
      const result: IAny = await dataConnector.actions.create(requestBody);
      const { notifyDescription, notifyType } = getEnrollNotifyInfo(result);
      notifyMessage && notifyMessage(t(notifyDescription), notifyType);
    } else {
      setIsSpecialCharacter(true);
    }
  };

  return (
    <Modal
      className="emaas-utility-modal"
      size="large"
      closeIcon={true}
      onClose={closeModal}
      open={showModal}
      closeOnDimmerClick={false}
    >
      <div className="utility-modal-header">{t(d.ADD_UTILITY_SERVICE)}</div>
      <Modal.Content className="utlity-modal-content">
        {progressTab ? (
          <ProgressTab utilityType={utilityTyp} {...ProgressTabProps} />
        ) : (
          <div className="utility-content">
            <div className="utility-type-container">
              {t(d.ADDUTILITYTYPE)}
              <div className="automatedButton">
                <Radio
                  label={t(d.AUTOMATED)}
                  name="Automated"
                  checked={utilityTyp === 'Automated'}
                  onChange={() => {
                    // SetSelectedUtilityProvider(JSON.parse(JSON.stringify({})) as IUtilityProviders)
                    setIsSpecialCharacter(false);
                    setUtilityTyp('Automated');
                  }}
                />
                <span className="automatedtxt">{t(d.AUTOMATEDTEXT)}</span>
              </div>
              <div className="manualButton">
                <Radio
                  label={t(d.MANUAL)}
                  name="Manual"
                  defaultChecked
                  checked={utilityTyp === 'Manual'}
                  onChange={() => {
                    // SetSelectedUtilityProvider(JSON.parse(JSON.stringify({})) as IUtilityProviders)
                    setIsSpecialCharacter(false);
                    setUtilityTyp('Manual');
                  }}
                />
                <span className="manualtxt">{t(d.MANUALTEXT)}</span>
              </div>
            </div>
            <hr className="hr-width-divider" />
            <div className="utility-form-container">
              <UpdatedChooseServiceTab {...chooseServiceProps} />
              <UtilityModalForm {...connectProps} />
              {/* <UtilityModalForm {...connectProps} /> */}
            </div>
          </div>
        )}
      </Modal.Content>
      {!progressTab && (
        <Modal.Footer>
          <div className="utility-modal-footer">
            <Button
              type="primary"
              content={t(d.SUBMIT)}
              onClick={() =>
                utilityTyp === 'Automated' ? submit() : manualSubmit()
              }
              disabled={
                utilityTyp === 'Automated'
                  ? isDisabled
                  : manualDisabled || AccountNumcheck
              }
            ></Button>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default UpdatedUtilityServiceModal;
